<template>
      <div class="documents dbox" 
      :v-if="documents"
      >

        <div class="dt-list">
          <div class="dt-list-item"
          v-for="document of documents"
          :key="document.artist_info_id"
          >

              <div class="dt-list-item--body">

                <div class="dt-list-item--text">
                  {{document.artist_info_name}}
                </div>
                <div 
                  class="dt-list-item--text"
                  v-html="document.info_txt"  
                >
                </div>
                <div class="dt-list-item--icon">
                  <div class="dt-icon-container">
                    <img 
                      src="static/icons/edit.svg" 
                      @click="e => onDocumentEdit(document)"
                      class="dt-icon v5 s1" 
                      alt="">
                  </div>
                </div>
                <div class="dt-list-item--icon">
                  <div class="dt-icon-container">
                    <img 
                      src="static/icons/delete.svg" 
                      @click="e => ondocumentDelete(document)" 
                      class="dt-icon v5 s1" 
                      alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>

        <div class="dbox-title-bar--options">
          <img 
            @click="adddocumentClick" 
            src="static/icons/add-icon.svg" 
            class="dt-icon v4" 
            alt="Add Document"
            ttile="Add Document"
          >
          <!-- <div class="button">
            <div class="dt-icon-container">
              <img 
                @click="adddocumentClick" 
                src="static/icons/add.svg" 
                class="dt-icon" 
                alt="">
            </div>
          </div> -->
        </div>

    </div>
</template>

<script>


export default {
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    selectedArtist: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
    }
  },
  computed: {
  },
  methods: {
    adddocumentClick: function(event) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: 'create_info',
          artist_id: this.selectedArtist.artist_id
        }
      });
    },
    ondocumentDelete: function(document) {
      this.$emit('documentDelete', document);
    },
    onDocumentEdit: function(document) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: 'edit_info',
          artist_id: this.selectedArtist.artist_id,
          artist_info_id: document.artist_info_id,
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>

.dt-list-item--text {
  // TODO! Change the max-width solution - This is only for 1920px window width. This is not responsive for all window sizes
  max-width: 487.4px;
  flex: 2.2;
  .span {
  }

  &:first-child {
    flex: 0.7;
  }
}


</style>
